import { render } from "./MessageEditor.vue?vue&type=template&id=522bd822"
import script from "./MessageEditor.vue?vue&type=script&lang=ts"
export * from "./MessageEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script